import Skeleton, { SkeletonCard } from '@/shared/components/Skeleton';
import { useIsMobile } from '@/shared/hooks/useMediaQuery';

export default function DashboardSkeleton({ theme: t }) {
  const mobile = useIsMobile();

  return (
    <div>
      {/* Summary cards */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: mobile ? 'repeat(2,1fr)' : 'repeat(4,1fr)',
        gap: mobile ? 10 : 14,
        marginBottom: mobile ? 20 : 28,
      }}>
        {[0, 1, 2, 3].map((i) => (
          <SkeletonCard key={i} theme={t} height={mobile ? 64 : 80} />
        ))}
      </div>

      {/* Charts */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: mobile ? '1fr' : '1fr 1fr',
        gap: mobile ? 14 : 20,
        marginBottom: mobile ? 20 : 28,
      }}>
        {[0, 1].map((i) => (
          <div key={i} style={{
            background: t.cardBg, borderRadius: 14, padding: 18,
            border: '1px solid ' + t.cardBorder, height: 240,
            display: 'flex', flexDirection: 'column', gap: 12,
          }}>
            <Skeleton width="30%" height={12} theme={t} />
            <Skeleton width="100%" height={180} borderRadius={10} theme={t} />
          </div>
        ))}
      </div>

      {/* Insights */}
      <div style={{
        background: t.cardBg, borderRadius: 14, padding: 18,
        border: '1px solid ' + t.cardBorder, marginBottom: 20,
        display: 'flex', flexDirection: 'column', gap: 10,
      }}>
        <Skeleton width="25%" height={12} theme={t} />
        <Skeleton width="80%" height={14} theme={t} />
        <Skeleton width="65%" height={14} theme={t} />
        <Skeleton width="70%" height={14} theme={t} />
      </div>

      {/* Recent transactions */}
      <div style={{
        background: t.cardBg, borderRadius: 14, padding: 18,
        border: '1px solid ' + t.cardBorder,
        display: 'flex', flexDirection: 'column', gap: 14,
      }}>
        <Skeleton width="35%" height={12} theme={t} />
        {[0, 1, 2, 3, 4].map((i) => (
          <div key={i} style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
            <Skeleton width={36} height={36} borderRadius={18} theme={t} />
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 6 }}>
              <Skeleton width="50%" height={12} theme={t} />
              <Skeleton width="30%" height={10} theme={t} />
            </div>
            <Skeleton width={60} height={14} theme={t} />
          </div>
        ))}
      </div>
    </div>
  );
}
